
export default {
    financial: {
        employmentStatus: '',
        employmentRole: '',
        occupation: '',
        industry: '',
        employerName: '',
        addressCountry: '',
        gross: '',
        paidFromEmployerIndicator: '',
        additionalNationalities: [],
        residentialReason: '',
        residentialReasonOther: '',
        correspondenceReason: '',
        explainResidenceReasonText: ''
    }
}
